import { useEffect } from "react";

export function useExitPdfMode(
  PDFMode,
  setPDFMode,
  importDataLogic,
  buildingName
) {
  useEffect(() => {
    if (PDFMode === "saved") {
      setPDFMode(false);
      importDataLogic(buildingName);
    }
    // Intentionally only reacts to PDFMode transitions. importDataLogic is
    // recreated each render, so including it would re-run on every render and
    // re-trigger the import, changing behavior.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [PDFMode]);
}
